import { useEffect, useState } from "react";
import api from "../lib/api";
import { boxesFor, fmtKc, articleLabel } from "../lib/catalogPrice";

export function TuscaniaPickerTab({ q, onAdd }) {
    const [arts, setArts] = useState(null);
    const [m2, setM2] = useState({});

    useEffect(() => {
        const t = setTimeout(() => api.get(`/supplier-catalog/articles?q=${encodeURIComponent(q || "")}&limit=150`).then((r) => setArts(r.data.articles)).catch(() => setArts([])), 200);
        return () => clearTimeout(t);
    }, [q]);

    if (!arts) return <div className="p-8 text-center text-slate-400 text-xs uppercase tracking-widest">Načítání…</div>;
    if (!arts.length) return <div className="p-8 text-center text-slate-500 text-sm">Nic nenalezeno v ceníku Tuscania.</div>;

    const add = (a) => {
        const want = Number(m2[a.id]) || 0;
        if (!want) return;
        const b = boxesFor(want, a.m2_per_box);
        onAdd({ name: articleLabel(a), description: `kód ${a.code} · ${b.boxes} bal. × ${a.m2_per_box} m² (požadováno ${want} m²)`, quantity: b.m2, unit: "m²", unit_price: a.sell_czk || 0 });
    };

    return (
        <div data-testid="picker-tuscania">
            {arts.map((a) => {
                const want = Number(m2[a.id]) || 0;
                const b = boxesFor(want, a.m2_per_box);
                return (
                    <div key={a.id} className="px-6 py-3 border-b border-slate-100 flex items-center justify-between gap-3 flex-wrap" data-testid={`picker-tuscania-${a.code}`}>
                        <div className="min-w-0 flex-1">
                            <div className="font-medium text-slate-900 truncate">{a.collection} — {a.color}, {a.format}{a.finish ? ` ${a.finish}` : ""}</div>
                            <div className="text-xs text-slate-500"><span className="font-mono text-orange-700 font-bold">{a.code}</span> · {a.m2_per_box} m²/bal. · <b>{fmtKc(a.sell_czk)}</b> / m²</div>
                        </div>
                        <div className="flex items-center gap-2 text-xs">
                            <input type="number" step="0.01" min="0" placeholder="m²" value={m2[a.id] ?? ""} onChange={(e) => setM2({ ...m2, [a.id]: e.target.value })} data-testid={`tuscania-m2-${a.code}`} className="w-20 border border-slate-300 px-2 py-1.5 rounded-sm text-right" />
                            {want > 0 && <span className="text-slate-600 whitespace-nowrap" data-testid={`tuscania-calc-${a.code}`}>{b.boxes} bal. = <b>{b.m2} m²</b> · {fmtKc(b.m2 * (a.sell_czk || 0))}</span>}
                            <button onClick={() => add(a)} disabled={!want} data-testid={`tuscania-add-${a.code}`} className="px-3 py-1.5 bg-slate-900 text-white uppercase tracking-wider font-semibold rounded-sm disabled:opacity-40">Vložit</button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
